import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from 'vue';
import { useDashboard } from '@/views/dashboard/dashboard.provider';
import { useDashboardChartUtils } from '@/views/dashboard/dashboard.charts.utils';
import dailyActiveInitiatorMachines from './daily-active-initiator-machines.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'daily-active-initiator-machines-controller',
  setup(__props) {

const dashboardChartUtils = useDashboardChartUtils();
const dailyActiveInitiatorMachinesConfig = useDashboard().gridUtilization.activeInitiatorMachines;
const options = computed(() => ({
  ...dailyActiveInitiatorMachinesConfig.value.options,
  toolbox: {
    feature: {
      myTool1: dashboardChartUtils.options.toolbox.feature.maximize({
        chartOptions: dailyActiveInitiatorMachinesConfig,
        chartId: dailyActiveInitiatorMachinesConfig.value.chartId,
        componentInstance: dailyActiveInitiatorMachines,
      }),
    },
  },
}));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(dailyActiveInitiatorMachines, {
    "chart-options": {
      ..._unref(dailyActiveInitiatorMachinesConfig),
      options: _unref(options),
    }
  }, null, 8, ["chart-options"]))
}
}

})